module.exports = __webpack_public_path__ + "img/1.89e4913e.png";